import { axios } from '@/utils/request'
const api = {
  source: '/finance/masterBill',
  create:'/finance/masterController',
}
// 获取列表数据
export function getSourceList (parameter) {
  return axios({
    url: api.source + '/list',
    method: 'get',
    params: parameter,
  })
}
export function getexportList (parameter) {
  return axios({
    url: '/finance/masterBill/export',
    method: 'get',
    params: parameter,
    responseType: 'arraybuffer',
    headers: {
      'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    }
  })
}
// 企业生成对账单
export function getenterGenerateState (parameter) {
  return axios({
    url: api.create + '/confirm',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}
// 客户自费生成对账单
export function getEnterpriseList (parameter) {
  return axios({
    url: api.create + '/create',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}
export const sourceExport = api.source + '/export'